export const kewajibanItems = [
  { id: 1, title: '1. Memperhatikan keberlanjutan kehidupan dan penghidupan Masyarakat' },
  { id: 2, title: '2. Memberikan akses untuk nelayan kecil yang sudah secara rutin melintas' },
  { id: 3, title: '3. Menghormati kepentingan pihak lain yang melakukan kegiatan atau Pemanfaatan Ruang di sekitarnya' },
  { id: 4, title: '4. Melakukan kegiatan secara ramah lingkungan' },
  { id: 5, title: '5. Menjaga kelestarian ekosistem Laut dan melakukan rehabilitasi sumber daya yang mengalami kerusakan' },
  { id: 6, title: '6. Menjaga kehidupan dan alur migrasi biota laut' },
  { id: 7, title: '7. Memberikan akses/tempat berlindung kepada siapapun dalam kondisi darurat' },
  { id: 8, title: '8. Melibatkan dan memberdayakan Masyarakat sekitar lokasi kegiatan/usaha' },
  { id: 9, title: '9. Membongkar bangunan dan instalasi di Laut apabila masa berlaku telah habis dan kegiatan/usaha tidak dilanjutkan lagi' },
  { id: 10, title: '10. Tidak menimbulkan konflik sosial' },
  { id: 11, title: '11. Tidak menimbulkan gangguan bagi pelaksanaan kepentingan keselamatan, pertahanan keamanan, dan memperhatikan kepentingan nasional' },
  { id: 12, title: '12. Menyampaikan laporan perolehan Perizinan Berusaha/Perizinan Non Berusaha' },
  { id: 13, title: '13. Menyampaikan laporan secara tertulis setiap 1 (satu) tahun kepada Menteri yang paling sedikit memuat:' },
  { id: 14, title: '14. Bermitra dengan penglola Kawasan Konservasi di Laut dalam rangka program kemitraan dan bina lingkungan dalam hal lokasi kegiatan berada dalam Kawasan Konservasi di Laut' },
  { id: 15, title: '15. Melaporkan pendirian dan/atau penempatan Bangunan dan Instalasi di Laut kepada instansi yang menyelenggarakan urusan pemerintahan di bidang hidrografi dan oseanografi' },
  { id: 16, title: '16. Menyediakan prasarana dan sarana pencegahan pencemaran dan pencegahan kerusakan sumber daya ikan serta lingkungannya' },
]

export function createEmptyKewajiban() {
  return {
    items: kewajibanItems.map((item) => ({
      id: item.id,
      hasil_penilaian: '',
    })),
  }
}
